module.exports = __webpack_public_path__ + "static/media/R-330XLHD_CrossSection.e5809b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/fr/R-330XLHD_CrossSection.png
// module id = 496
// module chunks = 0